import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isDefaultColorSystem } from 'utils/functions';

const TypographyLink = ({ onClick, label, labelKey, children, ...props }) => {
    const { t } = useTranslation();
    return (
        <Typography
            onClick={onClick}
            fontWeight={600}
            sx={[
                {
                    color: (theme) => (isDefaultColorSystem() ? '#cb002b' : theme.palette.secondary.main),
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    ml: 1
                },
                props?.sx,
            ]}
            {...props}
        >
            {children || label || t(labelKey)}
        </Typography>
    );
};

export default TypographyLink;
